var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-building-icon lucide-building",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h.01"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6h.01"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h.01"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h.01"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6h.01"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 16,
    height: 20,
    rx: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.8eef00d93a17b5086dd08482deed20c7.svg";
export { ForwardRef as ReactComponent };